import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";
import FitText from "react-textfit";

import Placeholder from "components/Placeholder";

export const StyledPlaceholder = styled(Placeholder)(({ theme }) => ({
  marginBottom: 10,
  [theme.breakpoints.up("mobile")]: {
    textAlign: "left",
    marginBottom: 20,
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  marginBottom: 10,
  [theme.breakpoints.up("mobile")]: {
    textAlign: "left",
    marginBottom: 20,
  },
}));

export const StyledFitText = styled(FitText)(({ theme }) => ({
  maxHeight: 55,
  [theme.breakpoints.up("mobile")]: {
    maxHeight: "auto",
  },
}));
